export default {
    name: 'roles',
    component: () => import(/* webpackChunkName: "roles-layout" */ '@/modules/roles/layouts/Layout'),
    children: [
        {
            path: '',
            name: 'dashboard.roles.index',
            component: () => import(/* webpackChunkName: "roles-index" */ '@/modules/roles/views/Index'),
        },
        {
            path: 'create',
            name: 'dashboard.roles.create',
            component: () => import(/* webpackChunkName: "roles-create" */ '@/modules/roles/views/Create'),
        },
        {
            path: ':id/edit',
            name: 'dashboard.roles.edit',
            component: () => import(/* webpackChunkName: "roles-edit" */ '@/modules/roles/views/Edit'),
        },
    ]
}